import { COMPONENTS } from '../lib/constants';

export const MainBonusViewGrid = {
	size: 100,
	gap: 1,
	name: 'main',
	padding: {
		top: 5,
		bottom: 5,
		left: 5,
		right: 5,
		landscape: {
			top: 3,
			bottom: 0,
			left: 5,
			right: 5
		},
		portrate: {
			top: 1,
			bottom: 1,
			left: 3,
			right: 3
		}
	},
	main: [
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'leftgrid',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'leftgrid',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 14
					},
					{
						name: COMPONENTS.REEL,
						bounds: {
							width: 1144,
							height: 680,
							offsetY: -8
						},
						size: 75
					}
				]
			}
		},
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'rightgrid',
			size: 25,
			type: 'PortrateGridController',
			config: {
				name: 'rightgrid',
				size: 100,
				gap: 0,
				align: 'left',
				padding: {
					left: 12
				},
				main: [
					{
						name: 'empty',
						size: 4
					},
					{
						name: COMPONENTS.INFO_BUTTONS,
						size: 9,
						align: 'top_right',
						bounds: {
							width: 180,
							height: 100
						}
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'leftgrid-land',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'leftgrid',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 14
					},
					{
						name: COMPONENTS.REEL,
						bounds: {
							width: 1144 / 2,
							height: 680 / 2
						},
						size: 75
					}
				]
			}
		},
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'rightgrid',
			size: 25,
			type: 'PortrateGridController',
			config: {
				name: 'rightgrid',
				size: 100,
				gap: 0,
				align: 'left',
				padding: {
					left: 12
				},
				main: [
					{
						name: 'empty',
						size: 5
					},
					{
						name: COMPONENTS.INFO_BUTTONS,
						size: 14,
						align: 'top_right',
						bounds: {
							width: 120,
							height: 100
						}
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'uppanel',
			size: 14,
			type: 'LandscapeGridController',
			config: {
				size: 100,
				gap: 1,
				padding: {
					top: 0,
					bottom: 0,
					left: 5,
					right: 5
				},
				name: 'logogrid',
				main: [
					{
						name: COMPONENTS.INFO_BUTTONS,
						visible: false
					}
				]
			}
		},
		{
			name: COMPONENTS.REEL,
			bounds: {
				width: 1144 / 2,
				height: 680 / 2
			},
			align: 'top',
			size: 33
		}
	]
};
